// @flow
import types from './notificationConstants';

const INIT_STATE = {
    notifications: [],
    unreadNotifications: [],
    preferences: null,
    preferencesSaving: false,
    loading: false,
    success: null
};

const Notification = (state = INIT_STATE, action) => {
    switch (action.type) {
        case types.CLEAR_STATE:
            return {
                ...INIT_STATE
            }
        //Get Notifications
        case types.GET_NOTIFICATIONS:
            return {
                ...state,
                loading: true
            };
        case types.GET_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notifications: action.payload.items,
                loading: false,
                error: null
            };
        case types.GET_NOTIFICATIONS_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        case types.GET_NOTIFICATIONS_UNREAD:
            return {
                ...state,
                loading: true
            };
        case types.GET_NOTIFICATIONS_UNREAD_SUCCESS:
            return {
                ...state,
                unreadNotifications: action.payload.items,
                loading: false,
                error: null
            };
        case types.GET_NOTIFICATIONS_UNREAD_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        //Get Notifications

        //Mark one as read — optimistic like mark-all/dismiss: drop it from the
        //unread list and flip the row in the full list; put it back on failure.
        case types.PATCH_NOTIFICATION:
            return {
                ...state,
                unreadNotifications: (state.unreadNotifications || []).filter(n => n.id !== action.payload),
                notifications: (state.notifications || []).map(n => n.id === action.payload ? { ...n, isRead: true } : n)
            };
        case types.PATCH_NOTIFICATION_SUCCESS:
            return {
                ...state,
                error: null
            };
        case types.PATCH_NOTIFICATION_FAILED: {
            const notifications = (state.notifications || []).map(n => n.id === action.id ? { ...n, isRead: false } : n);
            const reverted = notifications.find(n => n.id === action.id);
            const unread = state.unreadNotifications || [];
            return {
                ...state,
                notifications,
                unreadNotifications: reverted && !unread.some(n => n.id === action.id)
                    ? [reverted, ...unread]
                    : unread,
                error: action.payload
            };
        }
        //Mark one as read

        //Notification preferences
        case types.GET_PREFERENCES:
            return { ...state, loading: true };
        case types.GET_PREFERENCES_SUCCESS:
            return { ...state, preferences: action.payload, loading: false, error: null };
        case types.GET_PREFERENCES_FAILED:
            return { ...state, error: action.payload, loading: false };
        case types.PUT_PREFERENCES:
            return { ...state, preferencesSaving: true };
        case types.PUT_PREFERENCES_SUCCESS:
            return {
                ...state,
                preferences: { ...(state.preferences || {}), ...action.payload },
                preferencesSaving: false,
                error: null
            };
        case types.PUT_PREFERENCES_FAILED:
            return { ...state, error: action.payload, preferencesSaving: false };
        //Notification preferences

        //Mark all as read — optimistic; flip IsRead in both local lists
        case types.MARK_ALL_READ:
            return {
                ...state,
                unreadNotifications: [],
                notifications: (state.notifications || []).map(n => ({ ...n, isRead: true }))
            };
        case types.MARK_ALL_READ_SUCCESS:
            return { ...state, error: null };
        case types.MARK_ALL_READ_FAILED:
            return { ...state, error: action.payload };

        //Dismiss — optimistic; remove from both lists
        case types.DISMISS_NOTIFICATION:
            return {
                ...state,
                notifications: (state.notifications || []).filter(n => n.id !== action.payload),
                unreadNotifications: (state.unreadNotifications || []).filter(n => n.id !== action.payload)
            };
        case types.DISMISS_NOTIFICATION_SUCCESS:
            return { ...state, error: null };
        case types.DISMISS_NOTIFICATION_FAILED:
            return { ...state, error: action.payload };

        default:
            return state;
    }
};

export default Notification;
